export default __webpack_public_path__ + "static/mini-right-angle-b75ed3fbd55bb384862a177df0dded2a.png";